webpackJsonp([80],{

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1258);


/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(165);

var _datetime2 = _interopRequireDefault(_datetime);

var _enGb = __webpack_require__(775);

var _enGb2 = _interopRequireDefault(_enGb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-gb', _enGb2.default);

/***/ })

},[1257]);


// WEBPACK FOOTER //
// app/datetime.en-gb-a40d82499e161b23ce30.js